import { Typography } from "@material-ui/core";
import moment from "moment";
import React from "react";
import { StatisticSourceOrdersModel } from "../../../../../../server/routes/statistic/types";
import { Row } from "../../../../components/Table/types";
import numberFormat from "../../../../utils/formatNumber";
import { Columns } from "./columns/types";

const itemsToRows = (
  rows: Row<Columns>[],
  item: StatisticSourceOrdersModel
): Row<Columns>[] => {
  let firstRow = true;
  item.periods.forEach((period) => {
    rows.push({
      cells: {
        marketplace: firstRow
          ? {
              value: item.marketplace.name,
              CellProps: { rowSpan: item.periods.length },
            }
          : { absent: true },
        period: {
          component: (
            <>
              <Typography component={"span"}>
                {moment(period.fromDate).format("DD.MM.Y")}
              </Typography>
              {" - "}
              <Typography component={"span"}>
                {moment(period.toDate).format("DD.MM.Y")}
              </Typography>
            </>
          ),
        },
        turnoverValue: { value: numberFormat(period.turnover.value, 0) },
        turnoverFraction: { value: numberFormat(period.turnover.fraction, 1) },
        marginalityValute: {
          value: numberFormat(period.marginality.valute, 0),
        },
        marginalityFraction: {
          value: numberFormat(period.marginality.fraction, 1),
        },
        marginalityPercent: {
          value: numberFormat(period.marginality.percent, 1),
        },
        markup: { value: numberFormat(period.markup, 2) },
      },
    });
    firstRow = false;
  });
  return rows;
};
export default itemsToRows;
